import { createFeatureSelector, createSelector } from '@ngrx/store';
import { sessionUserData } from '../../interfaces/states-data';

export const sessionUserDataState = createFeatureSelector<sessionUserData>('sessionUserState');

export const getSessionUserData = createSelector(
    sessionUserDataState,
    (state: sessionUserData) => state
);
